import { InputRadio } from '@/components/atoms';
import { CONSTANTS } from '@/utils';

const CatalogSourceFilter = ({ 
  selectedTenant = [],
  onChangeTenant = () => {},
  title = "Penyedia Konten"
}) => {
 
    
  return ( 

    <div className="border-b py-5">
        <div className="mb-3 flex justify-between">
            <div className="text-sm font-semibold">{title}</div>
           
        </div>
        <div>
            <div className="flex flex-col space-y-2">
            {CONSTANTS.CATALOG_SOURCE_OPTIONS.map((option) => (
                <InputRadio
                    key={option.label}
                    label={option.label}
                    checked={String(selectedTenant) === String(option.value)}
                    onChange={() => onChangeTenant(option.value)}
                />
            ))}
            </div>
        </div>
    </div> 
  );
};

export default CatalogSourceFilter;